/* eslint-disable import/prefer-default-export */
import { camelCase } from 'lodash';

import { Question, Section } from './data';

export function generateIdName(section: Section, question: Question) {
  return [section?.label, question.label].filter((l) => !!l).map((l) => camelCase(l)).join('.');
}
